import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-error-page',
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ErrorPageComponent implements OnInit {

  errorCode: string;

  constructor(private route: ActivatedRoute, router: Router) {
  }

  ngOnInit() {
    this.errorCode = this.route.snapshot.params.errorCode;
    // this.route.snapshot.data['errorCode'];
  }


}
